const GROUPS = [
  {
    name: "Equipo de gestión",
    participants: [
    "daniel.serrano@griddo.io",
    "carmen.martin@griddo.io",
    "sara.regueira@griddo.io",
    "isabella.otero@griddo.io",
    "evelyn.bestilleiro@griddo.io",
    "gloria.rodrigo@secuoyas.com",
    "majo.dejuan@secuoyas.com",
    "jorge.fernandez@secuoyas.com",
    "raquel.rivera@secuoyas.com",
    "gonzalo.villar@secuoyas.com",
    "ana.gonzalez@secuoyas.com"
    ],
    camelSteps: [],
    totalSteps: 0,
    extraSteps: 0
  },
  {
    name: "Equipo de desarrolladores",
    participants: [
      "daniel.rossello@griddo.io",
      "enrique.sanz@griddo.io",
      "francis.vega@griddo.io",
      "sergio.rodenas@griddo.io",
      "guillermo.hernandez@griddo.io",
      "diego.bejar@griddo.io",
      "orencio.ramirez@griddo.io",
      "fernando.demorais@secuoyas.com",
      "gonzalo.hernandez@secuoyas.com",
      "ana.jaime@secuoyas.com",
      "alba.lopez@secuoyas.com",
      "miguel.tallon@secuoyas.com",
      "lidia.sanchez@secuoyas.com",
      "manuel.molina@secuoyas.com",
      "agustin.manessi@secuoyas.com",
      "carlosdio.garcia@secuoyas.com",
      "daniel.huertas@secuoyas.com",
      "isaac.morcillo@secuoyas.com",
    ],
    camelSteps: [],
    totalSteps: 0,
    extraSteps: 0
  },
  {
    name: "Equipo de diseñadores",
    participants: [
      "maite.antolin@griddo.io",
      "clara.iglesias@secuoyas.com",
      "carlos.denova@secuoyas.com",
      "julieta.kozlowski@secuoyas.com",
      "olga.casajuana@secuoyas.com",
      "cristina.garcia@secuoyas.com",
      "luisa.rodriguez@secuoyas.com",
      "miguel.gonzalez@secuoyas.com",
    ],
    camelSteps: [],
    totalSteps: 0,
    extraSteps: 0
  },
];

export { GROUPS };
